import {Simplex as BaseSimplex} from 'services/sports/default/simplex';
import Const from 'constants';
import {addRoleSuffix, getPlayersGroupUID, getSimplexUnitName} from 'helpers/simplex-helper';
import Action from 'actions';
import RuleBuilder from 'services/simplex/rule-builder';
import ArrayHelper from 'helpers/array-helper';

export default class SimplexSinglegame extends BaseSimplex {
    minTeams({incomingValues: {modes}}) {
        const {playersData, sportConfig} = Action.getState();
        const {preparedPlayers} = playersData;
        const players = preparedPlayers.groupedBy.allowedPositions();

        const teams = {};
        players.map((player) => {
            if (player.isDefender) {
                return;
            }
            if (!teams.hasOwnProperty(player.team)) {
                teams[player.team] = [];
            }
            teams[player.team].push(player);
        });

        const rows = {};
        const rules = [];
        const minTeams = Number(sportConfig.getConfigProp('minTeams'));

        Object.keys(teams).map((teamName) => {
            const players = teams[teamName];
            rows[teamName] = {};
            players.map((player) => {
                modes.map((mode) => {
                    const lpPlayerId = addRoleSuffix({
                        prefix: player.getId(),
                        role: mode,
                    });
                    rows[teamName][getSimplexUnitName(lpPlayerId)] = 1;
                });
            });
            rows[teamName][getPlayersGroupUID(teamName)] = -1;
        });

        if (ArrayHelper.countItems(teams) > minTeams) {
            let teamsRow = {};
            let generalObjective = {};
            Object.keys(rows).map((teamName) => {
                teamsRow[getPlayersGroupUID(teamName)] = 1;
                generalObjective[getPlayersGroupUID(teamName)] = 0;

                const ruleBuilder = RuleBuilder.fromAtLeast(0);
                ruleBuilder.addVars({...rows[teamName]});

                rules.push(ruleBuilder.createRule());
            });

            const ruleBuilder = RuleBuilder.fromAtLeast(minTeams);
            ruleBuilder.addVars({...teamsRow});

            rules.push(ruleBuilder.createRule());

            this.store.patchObj('additionalObjective', {minTeams: {...generalObjective}});
        } else {
            Object.values(rows).map((row) => {
                const ruleBuilder = RuleBuilder.fromAtLeast(1);
                ruleBuilder.addVars({...row});

                rules.push(ruleBuilder.createRule());
            });
        }
        // console.log('minTeams',[...rules]);
        return [...rules];
    }
}
